import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

const getDefaultState = () => {
  return {
    alertDetails:
    {
      message:"",
      type:"",
      display:false
    }
  }
}

const state = getDefaultState;

const mutations = {
  SetAlert(state,alertDetails)
  {
    state.alertDetails=alertDetails;
  },
  Reset(state)
  {
    Object.assign(state, getDefaultState());
  }
}

const actions = {
  SetAlert(state,alertDetails)
  {
    state.commit("SetAlert",alertDetails);
  },
  Reset(state)
  {
    state.commit("Reset");
  }
}
const getters = {
    AlertDetails:state=>state.alertDetails,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
